export class InformAgreedPriceTransactionsError extends Error {}
